<template>
<vue-dropzone
    v-show="show"
    id="dropzone"
    ref="myVueDropzone"
    :options="dropzoneOptions"
    :useCustomSlot="true"
    @vdropzone-success="vdropzone_handler_success"
    @vdropzone-sending="validateImageDimensions"
    @vdropzone-processing="vdropzone_handler_processing"
    @vdropzone-removed-file="vdropzone_handler_removed_file"
    @vdropzone-error="vdropzone_handler_error"
>
    <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">{{ $t('formularios.arrastra') }}</h3>
    </div>
</vue-dropzone>


</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    name: 'VueDropzone',
    props: {
        url: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            required: false,
            default: true
        },
        height: {
            type: Number,
            required: false,
        },
        width: {
            type: Number,
            required: false,
        },
        uploadMultiple: {
            type: Boolean,
            required: false,
            default: false
        },
        maxFiles: {
            type: Number,
            required: false,
            default: 1
        },
        maxFilesize: {
            type: Number,
            required: false,
            default: 20
        },
        acceptedFiles: {
            type: String,
            required: false,
            default: "image/jpeg,image/png,image/gif,image/bmp,image/tiff"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dropzoneOptions: {
                url: this.url,
                thumbnailWidth: 150,
                acceptedFiles: this.acceptedFiles,
                height: this.height,
                width: this.width,
                headers: {
                    'Accept': 'application/json',
                    'Hash-Teatro': localStorage.getItem('hash_teatro')
                },
                uploadMultiple: this.uploadMultiple,
                maxFiles: this.maxFiles,
                maxFilesize: this.maxFilesize,
                dictDefaultMessage: this.dictDefaultMessage,
                addRemoveLinks: true
            },
        }
    },
    methods: {
        validateImageDimensions(file, xhr, formData) {
            const reader = new FileReader();

            reader.onload = event => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const widthImg = img.width;
                    const heightImg = img.height;

                    if (this.width && this.height) {
                        if (widthImg !== this.width || heightImg !== this.height) {
                            this.$refs.myVueDropzone.dropzone.cancelUpload(file);
                            this.$refs.myVueDropzone.dropzone.removeFile(file);

                            this.$toast.error(`La imagen debe tener unas medidas exactas de ${this.width}x${this.height}px.`);
                        }
                    }
                };
            };

            reader.readAsDataURL(file);
        },
        vdropzone_handler_success(file, response) {
            this.$emit('success', file, response);
        },
        vdropzone_handler_processing(file) {
            this.$emit('processing', file);
        },
        vdropzone_handler_removed_file(file, error, xhr) {
            this.$emit('removed', file, error, xhr);
        },
        vdropzone_handler_error(file, response) {
            this.$emit('error', file, response);
        }
    },
    watch: {
        disabled(newVal) {
            if (newVal) {
                this.$refs.myVueDropzone.dropzone.disable();
            } else {
                this.$refs.myVueDropzone.dropzone.enable();
            }
        }
    },
    components: {
        vueDropzone: vue2Dropzone
    }
}
</script>
